<div class="badge-container">
  @if (count > 0) {
    <div class="badge stretch"
      [class.grey-4]="color === 'grey-4'"
      [class.negative]="color === 'negative'"
      >
      {{ count }}
    </div>
  }
  <ng-content></ng-content>
</div>
